module.exports = __webpack_public_path__ + "static/img/logo-pwc.b7c65f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-pwc.png
// module id = kz1B
// module chunks = 1